module.exports = __webpack_public_path__ + "static/media/Devices.1dc4737f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dashboard/Devices.jpg
// module id = 531
// module chunks = 0